module.exports = __webpack_public_path__ + "img/helder-transparant.a339db01d9fc7883c0291095a1377a51.svg";